import { Skeleton } from '@/components/ui/skeleton'

export const DiagramFallback = () => {
  return <Skeleton className="h-[500px] w-full border rounded-lg" />
}
